import { Mapper } from '../../../mappers';
import {
  GoogleAddress,
  GoogleAddressFields,
  GoogleAddressTypes,
  PlaceResult,
} from '../models';

export class GooglePlacesMapper extends Mapper<PlaceResult, GoogleAddress> {
  override from(source: PlaceResult): GoogleAddress {
    const addressComponents = source.addressComponents || [];
    const address = {
      AddressLine1: '',
      AddressLine2: '',
      City: '',
      StateProvince: '',
      Country: '',
      ZipCode: '',
      Latitude: null,
      Longitude: null,
    } as GoogleAddress;

    addressComponents.forEach((addressComponent) => {
      const type = addressComponent.types[0] as GoogleAddressFields;
      const type2 =
        addressComponent.types.length > 1
          ? (addressComponent.types[1] as GoogleAddressFields)
          : null;

      if (GoogleAddressTypes[type]) {
        const key = GoogleAddressTypes[type];
        const value = addressComponent[key];

        switch (type) {
          case GoogleAddressFields.StreetNumber:
            address.AddressLine1 = value;
            break;
          case GoogleAddressFields.Route:
            address.AddressLine1 += ` ${value}`;
            break;
          case GoogleAddressFields.Locality:
            if (type2 === GoogleAddressFields.Political || !type2) {
              address.City = value;
            }
            break;
          case GoogleAddressFields.PostalTown:
          case GoogleAddressFields.Sublocality:
          case GoogleAddressFields.Political:
            if (!type2) {
              address.City = value;
            }
            break;
          case GoogleAddressFields.AdministrativeAreaLevel1:
            address.StateProvince = value;
            break;
          case GoogleAddressFields.Country:
            address.Country = value;
            break;
          case GoogleAddressFields.PostalCode:
            address.ZipCode = value;
            break;
        }
      }
    });

    address.Latitude = source.location?.lat() ?? null;
    address.Longitude = source.location?.lng() ?? null;

    return address;
  }
}
